import { useTranslation } from "react-i18next";
import {
	Area,
	CartesianGrid,
	ComposedChart,
	Legend,
	Line,
	ResponsiveContainer,
	Tooltip,
	XAxis,
	YAxis,
} from "recharts";
import { useTheme } from "styled-components";
import { formatAmountInteger } from "../../lib/utils";

function XAxisTick(props) {
	const { x, y, payload, className } = props;
	return (
		<g transform={`translate(${x},${y})`}>
			<text
				x={0}
				y={0}
				dy={16}
				textAnchor="middle"
				fill="var(--textColor)"
				fontSize="12px"
				fontFamily="ProximaNova"
				className={className}
			>
				{payload.value}
			</text>
		</g>
	);
}

function YAxisTick(props) {
	const { x, y, payload, symbol } = props;

	return (
		<g transform={`translate(${x},${y})`}>
			<text
				x={0}
				y={0}
				dy={3}
				textAnchor="end"
				fill="var(--textColor)"
				fontSize="12px"
				fontFamily="ProximaNova"
			>
				{formatAmountInteger(payload.value)}
				{symbol}
			</text>
		</g>
	);
}

export const TrendedChart = <T extends object>({
	data,
	width = "100%",
	height = 245,
	symbol,
}: {
	data: T[];
	width?: string;
	height?: number;
	symbol?: string;
}) => {
	const theme = useTheme();
	const { t } = useTranslation();
	const { green } = theme.colors.primary;
	const tooltipFormatter = (value) => `${symbol || ""}${value}`;

	return (
		<div
			style={{
				width,
				height,
			}}
		>
			<ResponsiveContainer width="100%" height="100%">
				<ComposedChart
					data={data}
					margin={{ top: 10, right: 30, left: 15, bottom: 0 }}
				>
					<defs>
						<linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
							<stop offset="5%" stopColor={green} stopOpacity={0.8} />
							<stop offset="95%" stopColor={green} stopOpacity={0} />
						</linearGradient>
					</defs>
					<Legend verticalAlign="top" height={36} align="right" iconSize={12} />
					<XAxis
						dataKey="name"
						axisLine={false}
						tickLine={false}
						tick={<XAxisTick />}
						stroke="black"
						interval="preserveStartEnd"
					/>
					<YAxis
						tick={<YAxisTick symbol={symbol} />}
						axisLine={false}
						tickLine={false}
					/>
					<CartesianGrid
						strokeDasharray="3 3"
						vertical={false}
						stroke="#687D94"
					/>
					<Tooltip
						contentStyle={{
							backgroundColor: "var(--accentBg)",
              color: "var(--textColor)",
						}}
						formatter={tooltipFormatter}
					/>
					<Area
						type="monotone"
						dataKey={t("credit")}
						stroke={green}
						strokeWidth={3}
						fillOpacity={1}
						fill="url(#colorUv)"
					/>
					<Line
						type="monotone"
						dataKey={t("debit")}
						stroke="var(--textColor)"
						strokeWidth={2}
						dot={false}
					/>
				</ComposedChart>
			</ResponsiveContainer>
		</div>
	);
};
